// extracted by mini-css-extract-plugin
module.exports = {"links":"ErrorPage_links__nivoh"};